import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/imgcaptions/aiLogo.png'


const _hoisted_1 = { class: "born-start-container" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = { class: "topRout" }
const _hoisted_4 = { class: "nav-links" }
const _hoisted_5 = { class: "menuBox" }
const _hoisted_6 = { class: "menuLine" }
const _hoisted_7 = { class: "menuLine" }
const _hoisted_8 = { class: "menuLine" }
const _hoisted_9 = { class: "menuLine" }

import { useRouter, useRoute } from 'vue-router';
import { ref, onMounted,getCurrentInstance ,watch} from 'vue'
import menuPage from "@/components/common/menuPage.vue";
import { applicationDetail ,soundFieList} from "@/components/common/publicTxt.ts";
// 引入我的模块
import mainBox from "@/components/common/mainBox.vue";
// 参数

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { push, currentRoute } = useRouter();
// 引入下拉框
const menuShow=ref(false)//展示下拉列表
const mainBoxRef=ref()
const router = useRouter()
const route=useRoute()
watch(route, (to, from) => {
    console.log('================'+router.currentRoute)
    // console.log(to.path)
    
    activeMenu.value=to.path
    if(to.path=='/index/soundCloneTimbre'){
        activeMenu.value='/index/soundTimbre'
    }
    // let routeStr=localStorage.getItem('routeStr')
    // if(routeStr!=undefined){
    //     console.log('==========')
    //     console.log(routeStr)
    //     push(routeStr)
    //     activeMenu.value=routeStr
    // }

})
// onMounted(()=>{
//     let routeStr=localStorage.getItem('routeStr')
//     if(routeStr!=undefined){
//         console.log('==========')
//         console.log(routeStr)
//         push(routeStr)
//         activeMenu.value=routeStr
//     }else{
//         handleSelect('/index/phantomSound')
//     }
    
// })
onMounted(()=>{
    // activeMenu.value='/index/phantomSound'
    handleSelect('/index/phantomSound')
    // push('/index/soundCloneTimbre')
})
const handleSelect = (index: string) => {
  console.log(index)
  push(index);
  
};
// 
const closeSelect=(data)=>{
    console.log(data)
}
const activeMenu=ref('')
const toHome=()=>{
    console.log('首页')
    activeMenu.value=''
    localStorage.setItem('routeStr','/index/phantomSound')
    push('/index/phantomSound');
}
const menuTo=(data:string)=>{
    activeMenu.value=data
    localStorage.setItem('routeStr',data)
    push(data);
}

onMounted(() => {
  document.addEventListener("click", (event) => {
    // console.log(event);
    closeAll();
  });
});
const closeAll = () => {
//   DownloadShow.value = false;
  mainBoxRef.value?.closes();
//   indexControls.value=-1
//   overThisRow.value=-1
//   reNameIndex.value=-1
//   addFolderShow.value=false
 
};

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_header, { class: "header" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              class: "logoImg",
              onMousemove: _cache[0] || (_cache[0] = ($event: any) => (menuShow.value=true))
            }, null, 32)
          ])
        ]),
        _createElementVNode("div", {
          class: "text",
          onClick: toHome
        }, [
          _createTextVNode(_toDisplayString(_unref(applicationDetail).aiVoice.name) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(_unref(applicationDetail).aiVoice.version), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "menuOne",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (menuTo('/index/soundGeneration')), ["stop"])),
              style: _normalizeStyle(activeMenu.value=='/index/soundGeneration'?{'background':'#131416'}:'')
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "menuTxt" }, " 幻音TTS ", -1)),
              _withDirectives(_createElementVNode("span", _hoisted_6, null, 512), [
                [_vShow, activeMenu.value=='/index/soundGeneration']
              ])
            ], 4),
            _createElementVNode("div", {
              class: "menuOne",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (menuTo('/index/soundChange')), ["stop"])),
              style: _normalizeStyle(activeMenu.value=='/index/soundChange'?{'background':'#131416'}:'')
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "menuTxt" }, " 幻音VC ", -1)),
              _withDirectives(_createElementVNode("span", _hoisted_7, null, 512), [
                [_vShow, activeMenu.value=='/index/soundChange']
              ])
            ], 4),
            _createElementVNode("div", {
              class: "menuOne",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (menuTo('/index/soundTimbre')), ["stop"])),
              style: _normalizeStyle(activeMenu.value=='/index/soundTimbre'?{'background':'#131416'}:'')
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "menuTxt" }, " 音色库 ", -1)),
              _withDirectives(_createElementVNode("span", _hoisted_8, null, 512), [
                [_vShow, activeMenu.value=='/index/soundTimbre']
              ])
            ], 4),
            _createElementVNode("div", {
              class: "menuOne",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (menuTo('/index/soundSpace')), ["stop"])),
              style: _normalizeStyle(activeMenu.value=='/index/soundSpace'?{'background':'#131416'}:'')
            }, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "menuTxt" }, " 个人空间 ", -1)),
              _withDirectives(_createElementVNode("span", _hoisted_9, null, 512), [
                [_vShow, activeMenu.value=='/index/soundSpace']
              ])
            ], 4)
          ])
        ]),
        _createVNode(mainBox, {
          class: "topMain",
          ref_key: "mainBoxRef",
          ref: mainBoxRef,
          onCloseAll: closeAll
        }, null, 512),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "user-info" }, null, -1)),
        _withDirectives(_createVNode(menuPage, {
          class: "menuPageStyle",
          onClosemenu: _cache[5] || (_cache[5] = ($event: any) => (menuShow.value=false)),
          onOpenmenu: _cache[6] || (_cache[6] = ($event: any) => (menuShow.value=true)),
          nameInfo: _unref(applicationDetail).aiVoice
        }, null, 8, ["nameInfo"]), [
          [_vShow, menuShow.value]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_component_el_container, { class: "content" }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_KeepAlive, { include: ['initPage','soundGeneration','soundChange','soundTimbre','soundSpace','soundCloneTimbre'] }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ], 1024))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })
  ]))
}
}

})